import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import pageNo from '../pages'
import pageRouters from './pageRouters'

Vue.use(Router)
/* 加载进度 */
NProgress.configure({
  speed: 500,
  showSpinner: false
})
const routes = [
  {
    path: '/',
    component: pageNo,
    children: [
      ...pageRouters
    ]
  }
]
const router = new Router({
  routes: routes
})

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  if (localStorage.getItem('lastPwdTime')==null) NProgress.start()
  next();
});
 
// 进度条
router.afterEach(() => {
  NProgress.done()
})

// 解决路由重复单击报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err)=>err)
}

export default router
